import { render, staticRenderFns } from "./EtapaEndereco.vue?vue&type=template&id=293eea68"
import script from "./EtapaEndereco.vue?vue&type=script&lang=js"
export * from "./EtapaEndereco.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports